import { useEffect } from "react";
import { useForm } from "../../useForm";

import { Dialog } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";

import Input from "../../../controls/Input";
import DatePickerInput from "../../../controls/DatePickerInput";

const initialFValues = {
  name: "",
};
export default function InvoiceDetailsForm(props) {
  const { invoice, setOpen, isEdit } = props;

  const { values, setValues, errors, handleInputChange } = useForm(
    initialFValues,
    false,
  );

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  useEffect(() => {
    if (!isEdit) {
      setValues(invoice);
    }
  }, [invoice, isEdit, setValues]);

  return (
    <div className="flex h-full flex-col divide-y divide-[#E2E8F0] bg-white">
      <div className="flex min-h-0 flex-1 flex-col overflow-y-scroll py-6">
        <div className="px-4 sm:px-6">
          <div className="flex items-start justify-between">
            <Dialog.Title className="text-base font-semibold leading-6 text-[#0F172A]">
              Invoice details
            </Dialog.Title>
            <div className="ml-3 flex h-7 items-center">
              <button
                type="button"
                className="rounded-md bg-white text-[#64748B] hover:text-[#64748B] focus:outline-none focus:ring-2 focus:ring-[#2563EB]"
                onClick={() => setOpen({ childComponent: null, open: false })}
              >
                <span className="sr-only">Close panel</span>
                <XMarkIcon className="h-6 w-6" aria-hidden="true" />
              </button>
            </div>
          </div>
        </div>
        <div className="relative mt-6 flex-1 px-4 sm:px-6">
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            <div>
              <Input
                label="Invoice"
                name="invoice_number"
                onChange={handleInputChange}
                value={values.invoice_number}
                labelOn={true}
                disabled={!isEdit}
                type="text"
                className={
                  "mt-1 block w-full rounded-xl border border-[#E2E8F0] bg-white px-3 py-2.5 text-sm text-[#0F172A] shadow-sm transition focus:border-[#2563EB] focus:outline-none focus:ring-2 focus:ring-[#2563EB]/10 disabled:bg-[#F6F8FB] disabled:text-[#64748B]"
                }
                error={errors.invoice_number}
              />
            </div>
          </div>
          <div className="mt-3 grid grid-cols-2 gap-4">
            <div>
              <Input
                label="Received by"
                name="received_by"
                onChange={handleInputChange}
                value={values.received_by}
                labelOn={true}
                disabled={!isEdit}
                type="text"
                className={
                  "mt-1 block w-full rounded-xl border border-[#E2E8F0] bg-white px-3 py-2.5 text-sm text-[#0F172A] shadow-sm transition focus:border-[#2563EB] focus:outline-none focus:ring-2 focus:ring-[#2563EB]/10 disabled:bg-[#F6F8FB] disabled:text-[#64748B]"
                }
                error={errors.received_by}
              />
            </div>
            <div>
              <DatePickerInput
                label="Date"
                name="date"
                onChange={handleInputChange}
                value={values.date}
                labelOn={true}
                disabled={!isEdit}
                type="text"
                dateFormat={"LLL dd, YYY"}
                className={
                  "mt-1 block w-full rounded-xl border border-[#E2E8F0] bg-white px-3 py-2.5 text-sm text-[#0F172A] shadow-sm transition focus:border-[#2563EB] focus:outline-none focus:ring-2 focus:ring-[#2563EB]/10 disabled:bg-[#F6F8FB] disabled:text-[#64748B]"
                }
              />
            </div>
          </div>
          <div className="mt-3 grid grid-cols-2 gap-4">
            <div>
              <Input
                label="Supplier"
                name="supplier_name"
                onChange={handleInputChange}
                value={values.supplier_name}
                labelOn={true}
                disabled={!isEdit}
                type="text"
                className={
                  "mt-1 block w-full rounded-xl border border-[#E2E8F0] bg-white px-3 py-2.5 text-sm text-[#0F172A] shadow-sm transition focus:border-[#2563EB] focus:outline-none focus:ring-2 focus:ring-[#2563EB]/10 disabled:bg-[#F6F8FB] disabled:text-[#64748B]"
                }
              />
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-shrink-0 justify-end px-4 py-4">
        <button
          type="button"
          className="rounded-xl border border-[#E2E8F0] bg-white px-4 py-2 text-sm font-semibold text-[#0F172A] shadow-sm transition hover:border-[#2563EB] hover:bg-[#EFF6FF] hover:text-[#2563EB]"
          onClick={() => setOpen({ childComponent: null, open: false })}
        >
          Cancel
        </button>
        <button
          type="submit"
          className="ml-4 inline-flex justify-center rounded-xl border border-[#2563EB] bg-[#2563EB] px-4 py-2 text-sm font-semibold text-white shadow-sm transition hover:border-[#1D4ED8] hover:bg-[#1D4ED8] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#2563EB]"
          onClick={handleSubmit}
        >
          {isEdit ? "Save" : "Create"}
        </button>
      </div>
    </div>
  );
}
